import { useSelector } from "react-redux";
import { handleValidateCodevalue } from "../Utility/constant";
import CommonEmail from "./CommonEmail";
import { StyledGridContainer, StyledSubHeader } from "./Styled";
import TextFiledWithLabel from "./TextFieldWithLabel";
import PhoneNumberField from "./PhoneNumberField";

const CommonComm = ({showAlternateEmail=false, disableEmail= false,required=false ,requiredValue, isDetailPage,isViewMode,handleOnChange , isRequired,state} ) => {

  const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)

  return (
    <>
    
    <StyledSubHeader>
    {handleValidateCodevalue(internationalise,'COMMON_COMM_DETAILS')} 
    </StyledSubHeader>
    <StyledGridContainer>
    <PhoneNumberField
    isDetailPage={isDetailPage}
    isViewMode={isViewMode}
    name="phone"
    countryCodeName="phoneCountryCode"
    countryCode={state?.phoneCountryCode || "+91"}
    value={state?.phone}
    isRequired={requiredValue?.phone || false}
    handleOnChange={handleOnChange}
    />
    <PhoneNumberField
    isDetailPage={isDetailPage}
    isViewMode={isViewMode}
    name="altPhone"
    countryCodeName="altPhoneCountryCode"
    countryCode={state?.altPhoneCountryCode || "+91"}
    label={handleValidateCodevalue(internationalise,"COMMON_COMM_ALT_PHONE_NUMBER")}
    value={state?.altPhone}
    isRequired={isRequired}
    handleOnChange={handleOnChange}
    />
    <CommonEmail
    required = {required}
    isDetailPage = {isDetailPage}
    isViewMode={isViewMode || disableEmail}
    name = 'email'
    value = {state?.email}
    isRequired={requiredValue?.email || false}
    handleOnChange={handleOnChange}
    />

    {showAlternateEmail ? (
        <TextFiledWithLabel
            label={handleValidateCodevalue(internationalise,'COMMON_ALTERNATE_EMAIL_IDS')}
            name="alternateEmailIds"
            value={state?.alternateEmailIds}
            onChange={handleOnChange}
            disabled={isViewMode}
        />
    ) : (
    <TextFiledWithLabel
    sx = {{visibility : 'hidden'}}
    />
    )}
    </StyledGridContainer>

    
</>)
}

export default CommonComm

